import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createUser } from "../services/api";
import { toast } from "react-toastify";

function AdminCreateUser() {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phone: "",
    isAdmin: false,
  });

  const token = localStorage.getItem("token");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUser({
      ...user,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    createUser(user, token)
      .then(() => {
        toast.success("Utilisateur créé avec succès.");
        navigate("/admin");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Erreur lors de la création de l'utilisateur.");
      });
  };

  return (
    <div className="container py-5">
      <Link to="/admin" className="btn btn-outline-secondary mb-4">
        &larr; Retour au dashboard
      </Link>
      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="card-title mb-4">Créer un nouvel utilisateur</h4>

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Prénom</label>
                <input
                  className="form-control mb-3"
                  name="firstName"
                  value={user.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Nom</label>
                <input
                  className="form-control mb-3"
                  name="lastName"
                  value={user.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control mb-3"
              name="email"
              value={user.email}
              onChange={handleChange}
              required
            />

            <label className="form-label">Mot de passe</label>
            <input
              type="password"
              className="form-control mb-3"
              name="password"
              value={user.password}
              onChange={handleChange}
              required
            />

            <label className="form-label">Téléphone</label>
            <input
              className="form-control mb-3"
              name="phone"
              value={user.phone}
              onChange={handleChange}
            />

            <div className="form-check form-switch mb-4">
              <input
                className="form-check-input"
                type="checkbox"
                name="isAdmin"
                checked={user.isAdmin}
                onChange={handleChange}
              />
              <label className="form-check-label">Utilisateur Admin</label>
            </div>

            <button type="submit" className="btn btn-success me-2">
              Créer utilisateur
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => navigate("/admin")}
            >
              Annuler
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminCreateUser;
